import CodeSnippet from 'components/CodeSnippet';
import * as CODE from 'constants/email';
import { APIWrapper, LeftColumn, RightColumn } from 'components/ApiRef';
import Notification from 'components/Notification';
import Helmet from 'react-helmet';
import * as React from 'react';
export default {
  CodeSnippet,
  CODE,
  APIWrapper,
  LeftColumn,
  RightColumn,
  Notification,
  Helmet,
  React
};